import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

const _api_end_point_root = environment.apiURL;
const _magento_end_point_root = environment.magentoApiUrl;
const _api_version = environment.apiVersion;
const _magento_api_version = environment.magentoApiVersion;
export interface AppUrlConfig {
    apiEndpoint: string;
}

export const CommonTitle = {
    COMMON_TITLE_PREFIX : 'SRP -World of Sweets'
}

export const AuthApiEndPoints: AppUrlConfig = {
    apiEndpoint: _api_end_point_root + 'api/' + _api_version + '/o/'
};

export const ApiEndPoints: AppUrlConfig = {
    apiEndpoint: _api_end_point_root + 'web/' + _api_version + '/app/'
};

export const StoreApiEndPoints: AppUrlConfig = {
    apiEndpoint: _api_end_point_root + 'web/' + _api_version + '/store/'
};

export const AccountsApiEndPoints: AppUrlConfig = {
    apiEndpoint: _api_end_point_root + 'web/' + _api_version + '/accounts/'
};

export const PromotionApiEndPoints: AppUrlConfig = {
    apiEndpoint: _api_end_point_root + 'web/' + _api_version + '/promotion/'
};

export const RetailerApiEndPoints: AppUrlConfig = {
    apiEndpoint: _api_end_point_root + 'api/' + _api_version + '/accounts/'
};

export const MagentoApiEndPoints: AppUrlConfig = {
    apiEndpoint: _magento_end_point_root + 'rest/' + _magento_api_version +'/'
};

export const AddressLookupApiEndPoint: AppUrlConfig = {
    apiEndpoint: 'https://api.addressy.com/Capture/Interactive/'
};


@Injectable()
export class AppConfig {
    private config: Object = null;
    private env: Object = null;

    constructor(private http: HttpClient) { }

    public getConfig(key: any) {
        return this.config[key];
    }

    public getEnv(key: any) {
        return this.env[key];
    }
}
